import { Typography } from '@mui/material'
import TokTokDocDialog from '../../../Common/Dialog'
import { DeleteBackgroundIcon } from '../../../../assets/icons/icons'
import useStyles from './_styles'
import { DialogConfirmDeleteProps } from './_props'

export default function DialogConfirmDelete({ open, onClose, onConfirm }: DialogConfirmDeleteProps) {
    const classes = useStyles()

    return (
        <TokTokDocDialog
            isOpen={open}
            handleClose={onClose}
            handleSave={onConfirm}
            handleCancel={onClose}
            saveTitle="Supprimer"
            title="Êtes-vous sûr de vouloir supprimer la pièce-jointe ?"
            loading={false}
            disableEscape={false}
            isDeleteAction
            dialogProps={{
                fullScreen: false,
                disableScrollLock: false,
                PaperProps: {
                    className: classes.dialogPaperNoScroll,
                    style: { overflow: 'hidden' },
                },
                slotProps: {
                    backdrop: {
                        className: classes.deleteBackdrop,
                    },
                },
            }}
            classNames={{
                dialogTitle: classes.helpDraftTitle,
                paper: classes.helpDialogPaper,
            }}
        >
            <Typography className={classes.deleteText}>Après confirmation, la suppression sera définitive</Typography>
            <DeleteBackgroundIcon />
        </TokTokDocDialog>
    )
}
